// resources/js/form/products/heloc.js
let steps = [
    // STEP 1 — Address (full address; replaces the former postal-code-only step)
    {
        title: "__address__",
        beforeCreate() {},
        beforeNextStep() {},
        fields: [
            {
                name: "address",
                placeholder: '',
                type: "fulladdress",
                value: null,
                fieldOuterClass: "col-md-8 offset-md-2",
            },
        ],
        hideButtonsSection: false,
    },
    // STEP 2 — Credit score (QC only). Entire step skips outside QC.
    {
        hideIfCondition: (app) => {
            // Province now comes from the full address step (falls back to a
            // prepopped flat `state` value). This step is shown only in QC.
            const province = app.address?.province ?? app.state;
            return !!province && province !== "QC";
        },
        beforeCreate() {},
        beforeNextStep() {},
        title: "__in_credit_situation__",
        hideButtonsSection: true,
        fields: [
            {
                name: "in_credit_situation",
                type: "radio",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
            },
        ],
    },
    {
        title: "__more_information_needed__",
        beforeCreate() {},
        beforeNextStep: function() {},
        fields: [
            {
                label: "__first_name__",
                name: "first_name",
                type: "text",
                value: null,
                validationRules: "required|name",
                fieldOuterClass: 'col-md-8 offset-md-2',
            },
            {
                label: "__last_name__",
                name: "last_name",
                type: "text",
                value: null,
                validationRules: "required|name",
                fieldOuterClass: 'col-md-8 offset-md-2',
            },
            {
                label: "__email_address__",
                name: "email",
                type: "text",
                value: null,
                validationRules: "required|email",
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: "__address_city__",
                name: "city",
                type: "text",
                value: null,
                validationRules: "required",
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfCondition: (app) => !!(app.address?.city || app.city),
                attrs: { maxlength: 50 },
            },
            {
                label: "__province__",
                name: "state",
                type: "select",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfCondition: (app) => !!(app.address?.province || app.state),
            },
            {
                label: "__phone_number__",
                name: "phone_number",
                type: "text",
                value: null,
                validationRules: "required|canadianPhone",
                attrs: {maxlength: 10, minlength: 10},
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                textBottom: '__phone_number_sms_results__'
            },
        ],
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
];

export default steps;
